import { AvisInitialTypeLight } from './AvisInitialTypeLight';
import { TypeDescMarche } from './TypeDescMarche';
import { Procedure } from './Procedure';
import { TypeInfosRectif } from './TypeInfosRectif';
export class Rectificatif {

	public avisInitial: AvisInitialTypeLight;

	public description: TypeDescMarche;

	public procedure: Procedure;

	public infosRectif: TypeInfosRectif[];

	constructor() {
		this.avisInitial = new AvisInitialTypeLight();
		this.description = new TypeDescMarche();
		this.procedure = new Procedure();
		this.infosRectif = [];

	}
}
